
import { formatError } from "@/helpers/filters";
import AuthService from "../services/auth-service";

export default {
  name: "SendCode",
  components: {},

  data: () => ({
    email: null,
    dialog: false,
    dialogError: false,
    snackbar: false,
    snackbarColor: "info",
    snackbarMessage: "",
    shakeAnimated: false,
    sendMessage: null,
    errorMessage: null,
    rulesEmail: [
      (value) => !!value || "Obrigatório",
      (value) => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Email inválido";
      },
    ],
  }),
  methods: {
    showToast(message, color = "info") {
      this.snackbarMessage = message;
      this.snackbarColor = color;
      this.snackbar = true;
    },
    redirectToRecoverPassword(email) {
      if (email) {
        this.$store.state.user.email = email;
        this.$store.dispatch("auth/setEmail", email);
      }

      this.showToast("Antes de entrar sem senha, redefina sua senha de acesso.", "warning");

      setTimeout(() => {
        this.$router.push({
          path: "/recover-password",
          query: {
            ...this.$route.query,
            ...(email ? { email } : {}),
            reason: "first-login",
          },
        });
      }, 1000);
    },
    async submitCode() {
      if (!this.email) {
        this.showToast("Informe seu e-mail para receber o código.", "warning");
        this.shakeAnimated = true;
        setTimeout(() => { this.shakeAnimated = false }, 1000);
      } else {
        try {
          const response = await AuthService.sendCode(this.email)
          if (String(response?.code) === '403' && response?.message === 'FIRST_LOGIN_REDIRECT') {
            this.redirectToRecoverPassword(this.email)
            return
          }
          this.sendMessage = response.message
          this.$store.state.user.email = this.email;
          this.$store.dispatch("auth/setEmail", this.email);
          this.showToast("Código enviado. Verifique seu e-mail.", "success");
          this.dialog = true
          setTimeout(() => {
            this.dialog = false;
            this.$router.push({
              path: "/insert-code",
              query: this.$route.query,
            });
          }, 3000)
        } catch (error) {
          this.errorMessage = formatError(error.message)
          this.dialogError = true
          setTimeout(() => { this.dialogError = false }, 3000)
        }
      }
    },
  },
};